import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { flow, pick, keys } from 'lodash/fp';

import SearchLayout from './index.jsx';
import { reducer as searchLayoutReducer } from './duck';

export default ({
  mapStateToProps,
  propTypes,
  routeActions: actions,
  routeReducer,
}) => {
  const pickProps = flow(keys, pick)(propTypes);

  class RouteComponent extends PureComponent {
    static propTypes = propTypes;

    render() {
      return <SearchLayout {...pickProps(this.props)} />;
    }
  }

  // Declared after the class so the `{ Component, ... }` shorthand below keeps
  // returning the fully wrapped component, exactly as the decorators did.
  const Component = withRouter(
    connect(mapStateToProps, actions)(RouteComponent),
  );

  let reducer = [];

  if (searchLayoutReducer) {
    reducer = [...reducer, searchLayoutReducer];
  }

  if (routeReducer) {
    reducer = [...reducer, routeReducer];
  }

  return { Component, actions, reducer };
};
